import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComparablesHostComponent } from './comparables-host/comparables-host.component';
import { RouterModule } from '@angular/router';
import { ComparablesLeaseSearchComponent } from './components/searchForms/comparables-lease-search/comparables-lease-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PropertySearchFormComponent } from './components/searchForms/property-search-form/property-search-form.component';
import { ValuationsSearchFormComponent } from './components/searchForms/valuations-search-form/valuations-search-form.component';
import { ComparablesPropertiesWorkspaceComponent } from './components/workspaces/comparables-properties-workspace/comparables-properties-workspace.component';
import { ComparablesValuationsWorkspaceComponent } from './components/workspaces/comparables-valuations-workspace/comparables-valuations-workspace.component';
import { ComparablesPropertiesGridComponent } from './components/grids/comparables-properties-grid/comparables-properties-grid.component';
import { ComparablesLeasesFormComponent } from './components/forms/comparables-leases-form/comparables-leases-form.component';
import { ComparablesValuationsFormComponent } from './components/forms/comparables-valuations-form/comparables-valuations-form.component';
import { ComparablesWorkplaceComponent } from './components/workplace/comparables-workplace/comparables-workplace.component';
import { NavigationModule } from '../../navigation/navigation.module';
import { AppCommonModule } from '../../components/common/app-common.module';
import { ComparablesLeasesWorkspaceComponent } from './components/workspaces/comparables-leases-workspace/comparables-leases-workspace.component';
import { ComparablesValuationsGridComponent } from './components/grids/comparables-valuations-grid/comparables-valuations-grid.component';
import { ComparablesLeasesGridComponent } from './components/grids/comparables-leases-grid/comparables-leases-grid.component';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ComparablesInfobarComponent } from './components/infobar/comparables-infobar/comparables-infobar.component';
import { ComparablesPropertyInfobarPicturesComponent } from './components/infobar/comparables-property-infobar-pictures/comparables-property-infobar-pictures.component';

/**
 * The routes
 */
export const routerModule = RouterModule.forChild([{
  path: '',
  component: ComparablesHostComponent
}]);

/**
 * Translate loader
 * @param http HttpClient
 */
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/translation/lang-', '.json');
}

/**
 * Comparables module
 */
@NgModule({
    imports: [
        CommonModule,
        routerModule,
        GridModule,
        ExcelModule,
        DropDownsModule,
        ReactiveFormsModule,
        ButtonsModule,
        TranslateModule,
        UploadsModule,
        FormsModule,
        LayoutModule,
        InputsModule,
        AppCommonModule,
        DateInputsModule,
        NavigationModule
    ],
    declarations: [
        ComparablesHostComponent,
        ComparablesLeaseSearchComponent,
        PropertySearchFormComponent,
        ValuationsSearchFormComponent,
        ComparablesPropertiesWorkspaceComponent,
        ComparablesLeasesWorkspaceComponent,
        ComparablesValuationsWorkspaceComponent,
        ComparablesPropertiesGridComponent,
        ComparablesValuationsGridComponent,
        ComparablesLeasesGridComponent,
        ComparablesLeasesFormComponent,
        ComparablesValuationsFormComponent,
        ComparablesWorkplaceComponent,
        ComparablesInfobarComponent,
        ComparablesPropertyInfobarPicturesComponent
    ]
})
export class ComparablesModule { }
